/* Endloses Nachladen auf Kategorie- und Suchseiten (wie Glanzstücke).
   Die Seitennavigation bleibt im HTML (SEO, ohne JavaScript nutzbar) und wird per JS ausgeblendet. */
(() => {
  'use strict';
  const grid = document.querySelector('.collection-grid');
  let nav = document.querySelector('.lj-pagination');
  if (!grid || !nav || !('IntersectionObserver' in window) || !window.fetch) return;

  const nextUrl = (n) => {
    const links = [...n.querySelectorAll('a[href]')];
    const current = parseInt(n.querySelector('[aria-current="page"]')?.textContent, 10) || 1;
    const next = links.find((a) => {
      try { return parseInt(new URL(a.href, location.href).searchParams.get('page'), 10) === current + 1; }
      catch (e) { return false; }
    });
    return next ? next.href : null;
  };

  let url = nextUrl(nav);
  if (!url) return;

  nav.hidden = true;
  const sentinel = document.createElement('div');
  sentinel.className = 'lj-infinite-sentinel';
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'height:1px;width:100%';
  const status = document.createElement('p');
  status.className = 'lj-infinite-status';
  status.setAttribute('role', 'status');
  status.style.cssText = 'text-align:center;font-size:13px;color:var(--color-muted,#68616f);margin:24px 0;min-height:1em';
  nav.after(sentinel, status);

  let loading = false;
  const load = async () => {
    if (loading || !url) return;
    loading = true;
    status.textContent = 'Weitere Schmuckstücke werden geladen …';
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const newGrid = doc.querySelector('.collection-grid');
      const newNav = doc.querySelector('.lj-pagination');
      if (newGrid) {
        const frag = document.createDocumentFragment();
        [...newGrid.children].forEach((child) => frag.append(document.importNode(child, true)));
        grid.append(frag);
        if (window.lucide && typeof window.lucide.createIcons === 'function') window.lucide.createIcons();
      }
      url = newNav ? nextUrl(newNav) : null;
      status.textContent = '';
      if (!url) { observer.disconnect(); sentinel.remove(); }
    } catch (e) {
      // Bei Fehler: normale Seitennavigation wieder zeigen
      observer.disconnect();
      sentinel.remove();
      status.remove();
      nav.hidden = false;
    } finally {
      loading = false;
      // Sentinel noch sichtbar (kurze Seite)? Dann direkt weiterladen.
      if (url && sentinel.isConnected && sentinel.getBoundingClientRect().top < window.innerHeight + 800) {
        requestAnimationFrame(load);
      }
    }
  };

  const observer = new IntersectionObserver((entries) => {
    if (entries.some((e) => e.isIntersecting)) load();
  }, { rootMargin: '0px 0px 800px 0px' });
  observer.observe(sentinel);
  // Zusätzliche Prüfung beim Scrollen (z. B. bei schnellem Sprung ans Seitenende)
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    setTimeout(() => {
      ticking = false;
      if (url && sentinel.isConnected && sentinel.getBoundingClientRect().top < window.innerHeight + 800) load();
    }, 150);
  }, { passive: true });
})();
